const region = "us-east-1";
const origin = window.location.origin;

const dev = {
  appSettingsData: {
    // generate a file format limit of video file
    autoRefreshFrequency: 10000,
    allowedDomain: ["williamslea.com", "post.williamslea.co.uk"],
  },

  amplify_config: {
    Auth: {
      mandatorySignIn: true,
      region: "us-east-1",
      userPoolId: "us-east-1_pdqFGrvgH",
      userPoolWebClientId: "cmm7jfgsc5jivp033i4cfpn52",
    },
    oauth: {
      domain: "wl-idp-dev-web.auth.us-east-1.amazoncognito.com",
      redirectSignIn: `${origin}/auth`,
      redirectSignOut: `${origin}/auth`,
      responseType: "code", // or 'token', note that REFRESH token will only be generated when the responseType is code
      scope: ["email", "profile", "openid"],
    },
    API: {
      endpoints: [
        {
          name: "Transcribe",
          endpoint: "https://api.dev.transcribe.wl-engage.com",
          region: region,
        },
      ],
    },
  },
};
// type demoType = typeof demo

export type DevType = typeof dev;
export default dev;

// const region = "us-east-1";
// const origin = window.location.origin;

// const dev = {
//   appSettingsData: {
//     // generate a file format limit of video file
//     federatedEngageAIProvider: "wl-logostore-dev-idp",
//   },

//   amplify_config: {
//     Auth: {
//       mandatorySignIn: true,
//       region: "us-east-1",
//       userPoolId: "us-east-1_BtY3rnwXc",
//       userPoolWebClientId: "5n8elr1fd98rm5fppdrkjf5dbm",
//     },
//     oauth: {
//       domain: "wl-multi-idp-poc.auth.us-east-1.amazoncognito.com",
//       redirectSignIn: `${origin}/auth`,
//       redirectSignOut: `${origin}/auth`,
//       responseType: "code",
//       scope: ["openid", "profile", "email"],
//     },
//     API: {
//       endpoints: [
//         {
//           name: "logoCloud",
//           // endpoint: "https://api.dev.wl-dms.com",
//           endpoint: "https://api.wl-dev-logostore.com",
//           region: region,
//         },
//       ],
//     },
//   },
// };
// // type demoType = typeof demo

// export type DevType = typeof dev;
// export default dev;
